"use client"

import { Button, Card, Col, Row, theme } from "antd"
import Image from "next/image"
import FlashSaleDealsDesktop from "./FlashSaleDealsDesktop"
import { Fragment } from "react/jsx-runtime"
import Timmer from "./Timmer"
import Text from "@/components/common/Typography/Text"
import { getValidDayjs } from "@/utils/safeParse/getValidDayjs"
import dayjs from "dayjs"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth"
import { useTranslation } from "react-i18next"
import Link from "@/components/common/LinkNext"

const FlashSaleDeals = ({ flashSales }: any) => {
  const token = theme.useToken().token
  const isDesktop = useIsDesktop()
  const viewportWidth = useDevicePassedWidth((screenWidth) => screenWidth)
  const isMobileLayout = viewportWidth > 0 ? viewportWidth < 992 : !isDesktop
  const { t } = useTranslation()

  const validFlashSales = flashSales.filter((flashSale: any) => {
    return flashSale.items.some((i: any) => !!i.flashPrice && !!i.originalPrice)
  })

  const deals = validFlashSales.reduce((arr: any[], flashSale: any) => {
    return arr.concat(flashSale.items.filter((i: any) => {
      return !!i.flashPrice
        && !!i.originalPrice
        && getValidDayjs(i.productMetaData.startDate).diff(dayjs(), 'minute') > 0
    }))
  }, [])?.sort((f1: any, f2: any) => (f1.flashPrice - f2.flashPrice))

  if (!deals.length) {
    return <Fragment />
  }

  return (
    <>
      <Col span={24}>
        <Row justify={isMobileLayout ? 'start' : 'space-between'} align='middle' style={{ marginBottom: '2rem' }}>
          <Col className="home__deals-hotels--box-title" span={isMobileLayout ? 24 : undefined}>
            <Row style={{ marginBottom: 10 }} align='middle' justify='space-between' wrap={false} gutter={[15, 15]}>
              <Col flex="none">
                <Image
                  height={36}
                  width={173.11}
                  src={'/static/flash-sale.png'}
                  alt="Flash Sale"
                  style={{ width: '17.3rem', height: '3.6rem', objectFit: 'contain' }}
                />
              </Col>
              {isMobileLayout && (
                <Col flex="none">
                  <Link href="/hotels">
                    <Button type="link" style={{ paddingInline: 0, fontWeight: 600 }}>
                      {t("common.see_more")}
                    </Button>
                  </Link>
                </Col>
              )}
            </Row>
            <Row>
              <Timmer flashSale={validFlashSales[0]} />
            </Row>
          </Col>
          {!isMobileLayout && (
            <Col>
              <Card
                style={{
                  background: token.colorPrimary
                }}
                styles={{
                  body: {
                    paddingInline: '1rem',
                    paddingBlock: '0.5rem',
                  }
                }}
                size='small'
              >
                <Row>
                  <Text strong style={{ color: 'white', fontSize: '1.8rem' }}>
                    {(validFlashSales[0]?.slotTime?.startTime || '').split(':').slice(0, 2).join(':')} - {(validFlashSales[0]?.slotTime?.endTime || '').split(':').slice(0, 2).join(':')}
                  </Text>
                </Row>
                <Row>
                  <Text style={{ color: 'white' }}>
                    Đang diễn ra
                  </Text>
                </Row>
              </Card>
            </Col>
          )}
        </Row>
      </Col>
      <Col style={{ marginBottom: '3rem' }} span={24} className="home__deals-hotels--list-container">
        <FlashSaleDealsDesktop deals={deals} minWidth={992} />
        <FlashSaleDealsDesktop
          deals={deals}
          singleSlide
          autoPlay={3000}
          maxWidth={991}
        />
      </Col>
    </>
  )
}

export default FlashSaleDeals
